import type { StatesConfig } from 'xstate'
import type { TStep } from 'src/types'
import { getIntellioResumeTarget } from 'helpers/getIntellioResumeTarget'
import { useZustandGlobalStore } from 'zustandGlobalStore'
import { PageId } from 'constants/pages'

export const getXStateConfigIntlMw = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    always: [
      {
        target: getIntellioResumeTarget({
          pages,
          pageIds: {
            certificate: PageId.REPORT_INTL_MW,
            nameEntry: PageId.NAME_ENTRY_INTL_MW,
            offer: PageId.OFFER_INTL_MW,
            registration: PageId.REGISTRATION_INTL_MW,
            report: PageId.REPORT_INTL_MW,
          },
        }),
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
          SKIP_ONE_STEP: {
            target:
              index + 2 < pages.length
                ? pages[index + 2].pageId
                : pages[index].pageId,
          },
          SKIP_ONE_STEP_BACK: {
            target:
              index - 2 >= 0 ? pages[index - 2].pageId : pages[index].pageId,
          },
          POST_PAYMENT_CONTINUE: {
            target: PageId.REGISTRATION_INTL_MW,
          },
          ...(page.pageId === PageId.PATTERNS_IMPACT_INTL_MW && {
            PREVIOUS_FLOW_STEP: { target: PageId.HEAR_ABOUT_US_INTL_MW },
          }),
          ...(page.pageId === PageId.OFFER_INTL_MW && {
            NEXT_FLOW_STEP: { target: PageId.PAYMENT_INTL_MW },
          }),
          ...(page.pageId === PageId.PAYMENT_INTL_MW && {
            PREVIOUS_FLOW_STEP: [
              {
                cond: (): boolean =>
                  !!useZustandGlobalStore.getState()
                    .hasVisitedCancelOfferIntlMw,
                target: PageId.CANCEL_OFFER_INTL_MW,
              },
              { target: PageId.SPECIAL_DISCOUNT_INTL_MW },
            ],
          }),
        },
      },
    }),
    {},
  ),
  // [PageId.DOWNLOAD_ESA_INTL_MW]: {
  //   type: 'final',
  // },
})
